import React from "react";

export default function Footer() {
    return (
        <footer>
            <p className="footer"> &#169; 2022. Designed and programmed by John Mangahis. Have a good day! &#127810;</p>
        </footer>
    )
}